/**
 * 沿革ページで利用するJavaScript処理
 * - スクロールによるInviewアニメーション
 * - テキストスクロール領域のドラッグスクロール機能
 */
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimation);
    document.addEventListener('DOMContentLoaded', initDragScroll);
  } else {
    initScrollAnimation();
    initDragScroll();
  }

  function initScrollAnimation() {
    const inviewTarget = document.querySelectorAll('.c-inview-target');
    
    if (inviewTarget.length === 0) {
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -15% 0px',
      threshold: 0.1
    };

    function handleIntersection(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-show');
          observer.unobserve(entry.target);
        }
      });
    }

    const observer = new IntersectionObserver(handleIntersection, observerOptions);

    inviewTarget.forEach(function(element) {
      observer.observe(element);
    });
  }

  function initDragScroll() {
    // モバイルデバイス（タッチデバイス）の場合は処理を無効化
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      return;
    }

    const scrollerElements = document.querySelectorAll('.c-page-history-timeline__detail--text-scroller');
    
    if (scrollerElements.length === 0) {
      return;
    }

    scrollerElements.forEach(function(scrollerElement) {
      let isDragging = false;
      let startY = 0;
      let scrollTop = 0;

      scrollerElement.addEventListener('mousedown', function(event) {
        isDragging = true;
        startY = event.pageY - scrollerElement.offsetTop;
        scrollTop = scrollerElement.scrollTop;
        scrollerElement.style.cursor = 'grabbing';
        scrollerElement.style.userSelect = 'none';
        event.preventDefault();
      });

      document.addEventListener('mousemove', function(event) {
        if (!isDragging) {
          return;
        }
        event.preventDefault();
        const y = event.pageY - scrollerElement.offsetTop;
        const walk = (y - startY) * 2;
        scrollerElement.scrollTop = scrollTop - walk;
      });

      document.addEventListener('mouseup', function() {
        if (isDragging) {
          isDragging = false;
          scrollerElement.style.cursor = 'grab';
          scrollerElement.style.userSelect = '';
        }
      });

      scrollerElement.addEventListener('mouseleave', function() {
        if (isDragging) {
          isDragging = false;
          scrollerElement.style.cursor = 'grab';
          scrollerElement.style.userSelect = '';
        }
      });
    });
  }
})();

